module.exports = __webpack_public_path__ + "static/media/x-icon.32abcb57.svg";